// src/pages/NotFound/index.jsx
import React from 'react';
import { Button, Result } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <Result
        status="404"
        title={
          <div className="not-found-title">
            <span className="chinese-seal-large">失</span>
            文物失落
          </div>
        }
        subTitle="抱歉，您寻找的文物页面似乎已经消失在历史长河中..."
        extra={
          <Button 
            type="primary" 
            icon={<HomeOutlined />} 
            onClick={() => navigate('/')}
            size="large"
            className="home-btn"
          >
            返回文物首页
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;